import { Button, Card, Group, Stack, Text, TextInput } from '@mantine/core'
import { modals } from '@mantine/modals'
import { IconUser } from '@tabler/icons-react'
import { useState } from 'react'
import { userHooks } from '$src/lib/trpcHooks'

interface PersonalInfoCardProps {
  user: {
    id: number
    firstName: string
    lastName: string
    email: string | null
  }
}

export function PersonalInfoCard({ user }: PersonalInfoCardProps) {
  const handleEdit = () => {
    modals.open({
      title: 'Muokkaa tietoja',
      centered: true,
      children: <EditPersonalInfoForm user={user} />,
    })
  }

  return (
    <Card radius="md" withBorder>
      <Stack gap="md">
        <Group justify="space-between">
          <Group gap="sm">
            <IconUser size={20} />
            <Text fw={600}>Omat tiedot</Text>
          </Group>
          <Button variant="light" size="xs" onClick={handleEdit}>
            Muokkaa
          </Button>
        </Group>

        <Stack gap="xs">
          <div>
            <Text size="xs" c="dimmed">
              Nimi
            </Text>
            <Text>
              {user.firstName} {user.lastName}
            </Text>
          </div>
          <div>
            <Text size="xs" c="dimmed">
              Sähköposti
            </Text>
            <Text>{user.email}</Text>
          </div>
        </Stack>
      </Stack>
    </Card>
  )
}

function EditPersonalInfoForm({
  user,
}: {
  user: PersonalInfoCardProps['user']
}) {
  const [firstName, setFirstName] = useState(user.firstName)
  const [lastName, setLastName] = useState(user.lastName)
  const { mutateAsync: updateName, isPending } = userHooks.useUpdateName()

  const handleSubmit = async () => {
    if (!firstName.trim() || !lastName.trim()) {
      return
    }

    await updateName({
      id: user.id,
      data: {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
      },
    })
    modals.closeAll()
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !isPending) {
      handleSubmit()
    }
  }

  return (
    <Stack gap="md">
      <TextInput
        label="Etunimi"
        value={firstName}
        onChange={(e) => setFirstName(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        required
      />
      <TextInput
        label="Sukunimi"
        value={lastName}
        onChange={(e) => setLastName(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        required
      />
      <Button onClick={handleSubmit} loading={isPending}>
        Tallenna
      </Button>
    </Stack>
  )
}
